// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageHome .PageHome__footer {\n  border-top: 1px solid gray;\n  margin-top: 24px;\n  font-size: x-small; }\n", ""]);
// Exports
module.exports = exports;
